// A discount code is valid only if the customer typed it in this visit, for this cart.
// Codes from a link, a previous visit or a previous order are removed,
// so the customer must enter the code manually every time.
(() => {
  const KEY = 'bscent_discount_session';
  const CLEARED = 'bscent_discount_cleared';
  const el = document.currentScript;
  const hasCode = el?.dataset.hasCode === 'true';
  const cartToken = el?.dataset.cartToken || '';
  const updateUrl = el?.dataset.updateUrl || '/cart/update.js';
  const saved = sessionStorage.getItem(KEY);

  if (!hasCode) {
    if (saved && saved !== 'pending' && saved !== cartToken) sessionStorage.removeItem(KEY);
    return;
  }
  if (saved === 'pending') {
    sessionStorage.setItem(KEY, cartToken); // code just typed: bind it to this cart
    return;
  }
  if (saved && saved === cartToken) return; // same visit, same cart
  if (sessionStorage.getItem(CLEARED)) return; // already tried on this page session: avoid reload loops

  sessionStorage.removeItem(KEY);
  sessionStorage.setItem(CLEARED, '1');
  document.cookie = 'discount_code=; path=/; max-age=0';
  fetch(updateUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ discount: '' }),
  })
    .then(() => window.location.reload())
    .catch(() => {});
})();
